module.exports = __webpack_public_path__ + "static/media/load-rewards-screen-animation.efa6b531.gif";